// The change card in the platform agent's panel (D5). Wording from the Amigo design's copy sheet (Card, Rejecting,
// Summary first, Row status, Applying, Done, Rejected, Replaced, Changed in the meantime, Partly failed).
export default {
  // A password the shop created on approval, shown once (contracts §4 `revealed`).
  secret: {
    show: 'Wachtwoord tonen',
    hide: 'Wachtwoord verbergen',
    copy: 'Kopiëren',
    copied: 'Gekopieerd',
    once: 'Wordt alleen nu getoond. Kopieer het en bewaar het op een veilige plek.',
  },
  loading: 'De wijziging laden…',
  load_failed: 'Ik kon deze wijziging niet laden.',
  load_retry: 'Opnieuw proberen',
  // While the agent can't be reached, instead of the card's skeleton (QA119).
  load_waiting: {
    amigo: 'Deze wijziging verschijnt hier zodra Amigo weer beschikbaar is. Er is niets gewijzigd.',
    assistant: 'Deze wijziging verschijnt hier zodra de assistent weer beschikbaar is. Er is niets gewijzigd.',
  },
  // An approve that found the set approved already, in another tab or by the agent's follow-up (QA19).
  already_approved: 'Dit was al goedgekeurd, dus er hoefde niets meer te gebeuren.',
  action_failed: 'Dat is niet gelukt, dus er is niets gewijzigd. Probeer het zo meteen opnieuw.',
  removed: 'Verwijderd',
  retry: 'Opnieuw proberen',
  retry_one: '{{name}} opnieuw proberen',
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Goedgekeurd.',
    retried: 'Opnieuw geprobeerd.',
    rejected: 'Afgewezen.',
    // A restaurant skipped on a card with several restaurants (D18): its own set is rejected with this reason.
    skipped_restaurant: 'Op de kaart overgeslagen.',
  },
  done: {
    summary_one: 'Klaar. {{count}} wijziging toegepast.',
    summary_other: 'Klaar. {{count}} wijzigingen toegepast.',
    skipped_one: '{{count}} overgeslagen, er is niets gewijzigd.',
    skipped_other: '{{count}} overgeslagen, er is niets gewijzigd.',
  },
  partial: {
    summary_one: '{{applied}} van {{approved}} wijzigingen toegepast. {{count}} niet.',
    summary_other: '{{applied}} van {{approved}} wijzigingen toegepast. {{count}} niet.',
    detail_one: 'De {{applied}} zijn opgeslagen. Voor de {{count}} hieronder is niets gewijzigd.',
    detail_other: 'De {{applied}} zijn opgeslagen. Voor de {{count}} hieronder is niets gewijzigd.',
  },
  stale: {
    summary: '{{applied}} van {{approved}} wijzigingen toegepast.',
    detail_one: '{{count}} is in de tussentijd door iemand anders gewijzigd.',
    detail_other: '{{count}} zijn in de tussentijd door iemand anders gewijzigd.',
    reason:
      '{{name}} heeft dit om {{time}} gewijzigd naar {{value}}, voordat je het goedkeurde, dus ik heb het laten staan. Hier is het opnieuw, vanaf de nieuwe waarde:',
    decided_done:
      '{{name}} heeft het om {{time}} gewijzigd naar {{value}}, vóór uw goedkeuring, dus ik heb het laten staan. Het nieuwe voorstel is goedgekeurd op de eigen kaart.',
    decided_rejected:
      '{{name}} heeft het om {{time}} gewijzigd naar {{value}}, vóór uw goedkeuring, dus ik heb het laten staan. Het nieuwe voorstel is afgewezen.',
    decided_replaced:
      '{{name}} heeft het om {{time}} gewijzigd naar {{value}}, vóór uw goedkeuring, dus ik heb het laten staan. Het nieuwe voorstel is vervangen door een nieuwere kaart.',
    decided_expired:
      '{{name}} heeft het om {{time}} gewijzigd naar {{value}}, vóór uw goedkeuring, dus ik heb het laten staan. Het nieuwe voorstel is verlopen.',
  },
  undo_partly_one: '{{count}} hiervan kunnen niet ongedaan worden gemaakt.',
  undo_partly_other: '{{count}} hiervan kunnen niet ongedaan worden gemaakt.',
  undone: {
    summary_one: 'Ongedaan gemaakt. De {{count}} wijziging is weer zoals voorheen.',
    summary_other: 'Ongedaan gemaakt. De {{count}} wijzigingen zijn weer zoals voorheen.',
    detail: 'Het ongedaan maken is ook vastgelegd in het Amigo-logboek en onder Menu → Bewerkingsgeschiedenis.',
    partly_summary: 'Gedeeltelijk ongedaan gemaakt. {{undone}} van {{count}} wijzigingen zijn teruggezet.',
    partly_changed_one: '{{count}} is sindsdien door iemand anders gewijzigd en blijft daarom zoals het is.',
    partly_changed_other: '{{count}} zijn sindsdien door iemand anders gewijzigd en blijven daarom zoals ze zijn.',
    partly_kept_one: '{{count}} was al teruggezet naar de vorige staat.',
    partly_kept_other: '{{count}} waren al teruggezet naar de vorige staat.',
    partly_cannot_one:
      '{{count}} kan niet ongedaan worden gemaakt, zoals een verwijdering, dus dat blijft zoals het is.',
    partly_cannot_other:
      '{{count}} kunnen niet ongedaan worden gemaakt, zoals een verwijdering, dus die blijven zoals ze zijn.',
    partly_left_one: '{{count}} blijft zoals het is.',
    partly_left_other: '{{count}} blijven zoals ze zijn.',
  },
  summary: {
    group_one: '{{count}} gerecht: {{reason}}',
    group_other: '{{count}} gerechten: {{reason}}',
    group_names_more_one: '{{names}} en {{count}} meer',
    group_names_more_other: '{{names}} en {{count}} meer',
    average: '{{amount}} per gerecht gemiddeld',
    needs_look: 'Controle nodig',
    nothing_else: 'Verder verandert er niets',
  },
  labels: {
    waiting: 'In afwachting',
    skip: 'Overslaan',
    unskip: 'Overslaan ongedaan maken',
    approve_all: 'Alles goedkeuren',
    approve_one: '{{count}} goedkeuren',
    approve_other: '{{count}} goedkeuren',
    approve_all_count_one: 'Alle {{count}} goedkeuren',
    approve_all_count_other: 'Alle {{count}} goedkeuren',
    approve_row: 'Goedkeuren',
    reject: 'Negeren',
    reject_confirm: 'Afwijzen',
    back: 'Terug',
    why: {
      amigo: 'Waarom niet? (optioneel, Amigo leest dit)',
      assistant: 'Waarom niet? (optioneel, de assistent leest dit)',
    },
    hint: 'Of antwoord hieronder om iets te wijzigen.',
    show_all_one: 'Alle {{count}} wijzigingen tonen',
    show_all_other: 'Alle {{count}} wijzigingen tonen',
    show_less: 'Minder tonen',
    applying_one: '{{count}} wijziging toepassen…',
    applying_other: '{{count}} wijzigingen toepassen…',
    high_impact: 'Grote impact',
    done: 'Gereed',
    running: 'Bezig',
    show_changes: 'Wijzigingen tonen',
    hide_changes: 'Wijzigingen verbergen',
    rows: {
      skipped: 'Overgeslagen',
      applied: 'Toegepast',
      failed: 'Niet toegepast',
      changed: 'Intussen gewijzigd',
      kept: 'Ongewijzigd gelaten',
    },
    history: {
      amigo: 'Openen in het Amigo-logboek',
      assistant: 'Openen in het logboek van de assistent',
    },
    undo: 'Ongedaan maken',
    to: 'naar',
    from: 'van',
    rejected: 'Afgewezen',
    replaced: 'Vervangen',
    expired: 'Verlopen',
  },
};
